module.exports = __webpack_public_path__ + "images/specialOffer.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/specialOffer.png
// module id = 961
// module chunks = 2